import { render, staticRenderFns } from "./RolSearchChip.vue?vue&type=template&id=02e35844&"
import script from "./RolSearchChip.vue?vue&type=script&lang=js&"
export * from "./RolSearchChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports